module.exports = __webpack_public_path__ + "static/media/Booking-Details.f6463aac.png";